import { combineReducers } from 'redux'
import drawer from './drawer'
import steps from './steps'

export default combineReducers({
  drawer,
  steps,
})
